<template>
  <div :class="feedbackClass">
    {{ message }}
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    },
    feedbackClass: {
      type: String,
      required: true
    }
  }
}
</script>
